import { render, staticRenderFns } from "./SectionHero.vue?vue&type=template&id=1f6038c4&"
import script from "./SectionHero.vue?vue&type=script&lang=js&"
export * from "./SectionHero.vue?vue&type=script&lang=js&"
import style0 from "./SectionHero.vue?vue&type=style&index=0&id=1f6038c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports